import consumer from "./consumer";

function joinUserRoom(userRoom) {
  const room = consumer.subscriptions.create(
    {
      channel: "UsersChannel",
      room: userRoom,
    },
    {
      connected() {
        // Called when the subscription is ready for use on the server
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        if (data.type == "new_upload") {
          window.updateAudioList(data);
        }
      },
    }
  );

  return room;
}

window.joinUserRoom = joinUserRoom;
